import showSnackbar from '@/helpers/snackbar';

export async function confirmedDestroy(model, func = async m => m.destroy()) {
  // eslint-disable-next-line no-alert
  if (window.confirm('Wirklich löschen?')) {
    await func(model);
    showSnackbar({ text: 'Erfolgreich gelöscht.', color: 'success' });
    return true;
  }

  return false;
}
